<template>
  <div class="empty">
    <div class="empty-icon"></div>
    <p>{{ emptyTip }}</p>
  </div>
</template>
<script>
export default {
  name: 'empty-tip-components',
  props: ['emptyTip']
}
</script>
<style lang="less">
.empty {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .empty-icon {
    width: 119px;
    height: 156px;
    background: url(../assets/images/studyCenter/empty-icon.png) center
      center no-repeat;
    background-size: 100% 100%;
  }
  p {
    margin-top: 15px;
    font-size: 14px;
    color: rgba(102, 102, 102, 1);
    line-height: 20px;
  }
}
</style>